import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { icons } from '../../../assets/icons';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import useStableArr from '../../../utils/useStableArr';
import { LoaderComponent } from '../../../helpers/components/loader';
import Pagination from '../../../helpers/components/Pagination';
import { CSVLink } from 'react-csv';
import { convertDate } from '../../../helpers/modules';
import { handleCheck, handleCheckAll } from '../../../utils/checkUtilsCustomer';
import { getBillsByCustomer } from '../../../api/redux/slices/Customer';

const BillsClient = () => {
	const { bills, checkedList, total } = useSelector((state) => state.customer);
	const dispatch = useDispatch();
	const params = useParams();

	const [page, setPage] = useState(Number(params.page) || 1);
	const [newArr, setNewArr] = useState([]);
	const [isCheck, setIsCheck] = useState(false);
	const [search, setSearch] = useState('');
	const [loading, setLoading] = useState(false);
	const token = localStorage.getItem('accesstoken');

	//----------------------- GET ALL BILLS ---------------------------//
	const dispatchRequest = useCallback(
		(searchValue) => {
			setLoading(true);
			dispatch(
				getBillsByCustomer({
					token: token,
					page: searchValue ? 1 : page,
					search: searchValue,
				}),
			)
				.unwrap()
				.catch((err) => {
					console.error('Error fetching bills:', err);
				})
				.finally(() => setLoading(false));
		},
		[dispatch, page, token],
	);

	useEffect(() => {
		if (!search) {
			dispatchRequest('');
		} else if (search.length > 2) {
			dispatchRequest(search);
			setPage(1);
		}
	}, [dispatchRequest, search]);

	// --------------- RETRIVE LATEST BILLS DATA ---------------//
	useStableArr(bills, checkedList, setNewArr, setIsCheck);

	const headers = [
		{ label: 'NUMÉRO', key: 'reference' },
		{ label: 'DATE', key: 'createdAt' },
		{ label: 'TOTAL', key: 'total' },
	];

	const csvDeliveryReport = {
		filename: 'Factures.csv',
		data: checkedList.map(bill => ({
			reference: bill.reference,
			createdAt: convertDate(bill.createdAt, 'DD-MM-YYYY'),
			total: bill.total || 0,
		})),
		headers: headers,
	};
	
	return (
		<div id='billPage'>
			<div className='navbar'>
				<div className='left'>
					<div className='nav-search'>
						<input
							onChange={(e) => setSearch(e.target.value)}
							value={search}
							type='search'
							placeholder='Rechercher par référence...'
						/>
						<icons.FiSearch className='searchicon' />
					</div>
				</div>
				<div className='right'>
					<div className='right-items'>
						<CSVLink {...csvDeliveryReport} target='blank'>
							<button className='button-nature' title='exporter facture(s)'>
								<icons.BiExport />
							</button>
						</CSVLink>
					</div>
				</div>
			</div>
			<div id='head'>
				<div className='title-user'>
					<h1>Factures Proformat</h1>
				</div>
			</div>
			<div id='billsContent'>
				<table id='bills'>
					<thead>
						<tr id='titres'>
							<td className='input-check'>
								<input
									onChange={() => handleCheckAll(dispatch, newArr, setNewArr, isCheck, setIsCheck)}
									checked={isCheck}
									type='checkbox'
									className='checkbox'
								/>
								</td>
								<td>NUMÉRO</td>
								<td>DATE</td>
								<td>TOTAL</td>
								<td style={{ margin: 'auto' }}>ACTION</td>
							</tr>
					</thead>
					<tbody>
						{loading ? (
							<tr>
								<td colSpan={5}>
									<LoaderComponent margin='10%' />
								</td>
							</tr>
						) : newArr?.length > 0 ? (
							newArr.map((bill, index) => (
								<tr className='delivery' key={index}>
									<td className='input-check'>
										<input
											onChange={() => handleCheck(dispatch, newArr, setNewArr, bill?._id)}
											checked={bill?.checked ?? false}
											type='checkbox'
											className='checkbox'
										/>
									</td>
									<td>{bill.reference}</td>
									<td>{convertDate(bill?.createdAt, 'DD-MM-YYYY')}</td>
									<td>{bill?.total != null ? Number(bill?.total).toFixed(2) : 0} DT</td>
									<td className='last-delivery-element'>
										<Link
											to={`/client/bills/bill_details/${params.page}/${bill._id}`}
											className='link-delivery'
										>
											<icons.BsEye className='see-delivery' />
										</Link>
									</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan={5} style={{ textAlign: 'center', padding: '50px' }}>
									Aucune facture trouvée
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
			<Pagination page={page} setPage={setPage} pageLink={`/client/bills/`} total={total} />
		</div>
	);
};

export default BillsClient;